import ScrollReveal from '@/components/ui/ScrollReveal'

interface ImpactMetric {
  value: string
  label: string
}

const metrics: ImpactMetric[] = [
  {
    value: '+9%',
    label: 'Conversation engagement',
  },
  {
    value: '+10%',
    label: 'Task completion rate',
  },
  {
    value: '28',
    label: 'Distinct emotional states',
  },
]

function MetricItem({ metric }: { metric: ImpactMetric }) {
  return (
    <div>
      <p className="text-h2 md:text-display text-accent font-semibold">{metric.value}</p>
      <p className="text-body-sm text-text-secondary mt-2">{metric.label}</p>
    </div>
  )
}

export default function TobiImpact() {
  return (
    <div className="bg-surface rounded-2xl py-6 md:py-12 px-6 md:px-12">
      <ScrollReveal>
        <span className="text-label text-accent block mb-1">05</span>
        <p className="text-label uppercase tracking-widest text-text-muted mb-8">Impact</p>
      </ScrollReveal>

      <ScrollReveal delay={0.1}>
        <div className="flex flex-col md:flex-row md:justify-between gap-10 md:gap-8">
          {metrics.map((metric) => (
            <MetricItem key={metric.value} metric={metric} />
          ))}
        </div>
      </ScrollReveal>
    </div>
  )
}
